import { render, staticRenderFns } from "./InvitationsForm.vue?vue&type=template&id=545b2daa"
import script from "./InvitationsForm.vue?vue&type=script&lang=js"
export * from "./InvitationsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports